import React, { useState, useCallback, useRef, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../../dynamicFormBuilder/FormField'
import { PrimaryLayout } from './Layout';
import RenderSelectBoxCell from "../../../../../../common/RenderCell";

import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Editing,
    LoadPanel as GridLoadPanel,
    Lookup,
    Item,
    Toolbar,
    ColumnHeaderFilter,
    ColumnChooser,
    Selection,
    StateStoring
} from "devextreme-react/data-grid";
import DataSource from 'devextreme/data/data_source';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { Button, DropDownButton, Popup } from 'devextreme-react';
import { confirm } from 'devextreme/ui/dialog';

import { EMPTY_GUID, OMLocationOperations } from '../../../../../../enum/Enum';
import LocationHistoryList from '../../../../../../im/common/lists/LocationHistoryList';
import axios from "axios";
function PrimaryTab(props) {
    var currentUser = props.oidc.user;
    var accessToken = props.oidc.user.access_token;
    const formRefs = useRef({});
    const dataGrid = useRef(null);
    var updateUrl = "im/Transactionlocation/UpdateOMTransactionlocation";
    var insertUrl = "im/Transactionlocation/AddOMTransactionlocationDetails";
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const [dropDownItems, setDropDownItems] = useState([]);
    const [showLocationHistory, setShowLocationHistory] = useState({ visible: false, RItem: null, RLot: null });
    const buttonDropDownOptions = { width: 430, height: 400 };

    const detailRowId = props.formFields?.Rowid;
    const hasDetailLine =
        detailRowId && detailRowId !== EMPTY_GUID;

    const setPrimaryOperationItems = useCallback(() => {
        const id = "DisplayLocationHistory";
        const config = OMLocationOperations[id];
        setDropDownItems([
            {
                id,
                name: config.name,
                disabled: !props.formFields?.ItemCode,
            },
        ]);
    }, [props.formFields?.ItemCode]);

    useEffect(() => {
        setPrimaryOperationItems();
    }, [setPrimaryOperationItems]);

    const renderPrimaryOperationItem = useCallback((itemData) => {
        const isHeader = OMLocationOperations[itemData.id]?.isHeader === true;
        if (isHeader) {
            return (
                <div style={{ fontWeight: "bold", borderBottom: "1px solid #ccc" }}>{itemData.name}</div>
            );
        }
        const isDisabled = itemData.disabled === true;
        return (
            <span
                style={{
                    opacity: isDisabled ? 0.5 : 1,
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    pointerEvents: isDisabled ? "none" : "auto",
                }}
            >
                {itemData.name}
            </span>
        );
    }, []);

    const onPrimaryOperationItemClick = useCallback(
        (e) => {
            if (e.itemData?.disabled) return;
            const id = e.itemData?.id;
            const ff = props.formFields;
            if (id === "DisplayLocationHistory") {
                setShowLocationHistory({
                    visible: true,
                    RItem: ff?.itemId ?? null,
                    RLot: ff?.lotId ?? null,
                });
            }
        },
        [props.formFields]
    );
    /* The selected detail line, read through a ref so the store below can stay the same object for
       the grid's lifetime: a new store on every render would re-set the grid's dataSource option and
       reload the rows on every parent re-render (every keystroke in the form beside it). */
    const detailRowIdRef = useRef(detailRowId);
    detailRowIdRef.current = detailRowId;
    const locationDataSource = useMemo(() => createStore({
        key: 'rowid',
        loadParams: {
            transactionId: function () {
                return detailRowIdRef.current ?? EMPTY_GUID;
            }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/om/SaleOrder/GetTransactionDetailsLocations`,
        insertUrl: `${window._env_.REACT_APP_APIS}/${insertUrl}`,
        updateUrl: `${window._env_.REACT_APP_APIS}/${updateUrl}`,
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
                Key: detailRowIdRef.current,
            };
        }
    }), [accessToken, insertUrl, updateUrl]);

    useEffect(() => {
        setSelectedItemKeys([]);
        const grid = dataGrid.current?.instance();
        if (!grid) return;
        grid.refresh();
    }, [detailRowId]);

    const handlePrimaryFormLoad = useCallback(() => {

    }, []);
    const handleFieldChange = useCallback((name, value, e) => {

    }, []);
    const handleSelectionChange = useCallback((name, value, e) => {

    }, []);
    const handleCellValueChanged = (data) => {
        setSelectedItemKeys(data.selectedRowKeys);
    }

    const deleteRecords = useCallback(() => {
        var deleteUrl = "im/Transactionlocation/DeleteTransactionlocation";
        let result = confirm("<i>Are your sure you want to delete selected records?</i>", "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                axios.post(
                    `${window._env_.REACT_APP_APIS}/${deleteUrl}`,
                    selectedItemKeys,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                        },
                    }
                )
                    .then((res) => {
                        dataGrid.current.instance().refresh();
                    })
                    .catch(() => {
                        dataGrid.current.instance().endCustomLoading();
                    });
            }
        });
    }, [selectedItemKeys]);
    return (
        <div className="row" style={{ height: '100%', overflow: 'auto' }}>
            <div className="col-md-6 formfield-wrapper">
                <FormField
                    currrentUser={currentUser}
                    layoutId='4AE9B29E-620C-45B4-8079-FF8CA53C2F11'
                    layoutName='OMSalesOrderDataEntryPrimaryForm'
                    defaultFormSchema={PrimaryLayout}
                    formFields={props.formFields}
                    setformFields={props.setformFields}
                    handleFieldValueChange={handleFieldChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={formRefs}
                    onFormLoad={handlePrimaryFormLoad}
                    handleSelectedItemChange={handleSelectionChange}
                />
            </div>
            <div className="col-md-6">
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    ref={dataGrid}
                    selectedRowKeys={selectedItemKeys}
                    dataSource={locationDataSource}
                    showBorders={true}
                    columnAutoWidth={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    remoteOperations={true}
                    hoverStateEnabled={true}
                    height="100%"
                    onSelectionChanged={handleCellValueChanged}
                >                
                    <Selection mode="multiple" />
                    <ColumnHeaderFilter />
                    <Sorting visible={true} mode="multiple" />
                    <GridLoadPanel enabled={true}  showPane={true} showIndicator={true}/>
                    <Editing
                        mode="cell"
                        allowUpdating={true}
                        allowAdding={true}
                    />
                    <FilterRow visible={true} />
                    <Grouping autoExpandAll={false} />

                    <Column dataField="warehousecode" caption="Warehouse" allowSorting={false}
                        editCellRender={(cellElement) =>
                            RenderSelectBoxCell({
                                loadUrl: `${window._env_.REACT_APP_APIS}/id/Lookup/GetWarehouses`,
                                key: "id",
                                displayExpr: "name",
                                valueExpr: "id",
                                accessToken: accessToken,
                                defaultValue: cellElement.data.warehouseId,
                                sort: [{ selector: "name", desc: false }],
                                onValueChangeCallback: (value, text, additionalData) => {
                                    cellElement.setValue(({ value, text, additionalData }));
                                },
                            })
                        }
                        setCellValue={(rowData, newValue) => {
                            rowData.warehouseId = newValue.value;
                            rowData.warehousecode = newValue.text;
                        }}
                    >
                    </Column>
                    <Column dataField="locationcode" caption="Location" allowSorting={false}
                        editCellRender={(cellElement) =>
                            RenderSelectBoxCell({
                                loadUrl: `${window._env_.REACT_APP_APIS}/im/Lookup/GetLocations`,
                                key: "id",
                                loadParams:
                                {
                                    warehouseRowId: cellElement.data.warehouseId
                                },
                                displayExpr: "name",
                                valueExpr: "id",
                                accessToken: accessToken,
                                defaultValue: cellElement.data.locationId,
                                sort: [{ selector: "name", desc: false }],
                                onValueChangeCallback: (value, text, additionalData) => {
                                    cellElement.setValue(({ value, text, additionalData }));
                                },
                            })
                        }
                        setCellValue={(rowData, newValue) => {
                            rowData.locationId = newValue.value;
                            rowData.locationcode = newValue.text;
                        }}
                    >
                    </Column>
                    <Column dataField="containerCode" caption="Container" dataType="string" />
                    <Column dataField="quantityinventory" caption="Quantity" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                    <Column dataField="inBackorder" caption="Back Order" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                    <Column dataField="availableflag" caption="Available" dataType="string" >
                        <Lookup
                            dataSource={[{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }]}
                            displayExpr="name"
                            valueExpr="id"
                        />
                    </Column>
                    <Column dataField="availablereasoncode" caption="Reason" dataType="string" />
                    <Toolbar>
                        <Item
                            name="addRowButton"
                        />
                        <Item location="after">
                            <Button
                                onClick={deleteRecords}
                                icon="trash"
                                disabled={!selectedItemKeys.length || props.isCommittedTransaction === true}
                            />
                        </Item>
                        <Item location="after">
                            <DropDownButton
                                icon="fa fa-cogs"
                                stylingMode="text"
                                dropDownOptions={buttonDropDownOptions}
                                items={dropDownItems}
                                onItemClick={onPrimaryOperationItemClick}
                                displayExpr="name"
                                keyExpr="id"
                                disabled={!hasDetailLine}
                                itemRender={renderPrimaryOperationItem}
                            />
                        </Item>
                    </Toolbar>
                </DataGrid>
            </div>
            {showLocationHistory.visible && (
                <Popup
                    visible={showLocationHistory.visible}
                    onHiding={() => setShowLocationHistory({ visible: false, RItem: null, RLot: null })}
                    width="90vw"
                    height="90vh"
                    title="Location History"
                    showCloseButton={true}
                >
                    <LocationHistoryList RItem={showLocationHistory.RItem} RLot={showLocationHistory.RLot} />
                </Popup>
            )}
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(PrimaryTab);
